import { cookie } from './lister-utilities';

export const checkBasket = () => {
	const basketCookie = cookie('BasketSimple').get();

	if (basketCookie) {
		const productsInBasket = JSON.parse(decodeURIComponent(basketCookie));
		const products = productsInBasket?.Products?.map((item) => item.Sku);

		return {
			list: products,
			number: products.length,
		};
	}

	return null;
};

export function getCheckoutBaseUrl() {
	var checkoutUrlPrefix = new URL(window.checkoutUrlPrefix).origin;
	return checkoutUrlPrefix.replace('https://dev-', 'https://beta-');
}

export function getIsBecomingFiveStarMemberCookieValue() {
	return cookie('IsBecomingFiveStarMember').get();
}

export async function setIsBecomingMemberAsync(isBecomingMember) {
	const baseUrl = getCheckoutBaseUrl();
	const url = `${baseUrl}/HttpHandlers/ToggleFiveStarInBasketHandler.ashx?isBecomingFiveStarMember=${isBecomingMember}`;

	try {
		await fetch(url, {
			method: 'GET',
			credentials: 'include',
		});
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error(e);
	}
}
